import StyledLink from '../StyledLink'
import makeQueryString from './makeUrl/makeUrl'
import {
  ASSETS,
  EDIT,
  GIT_CONNECTIONS,
  MOVE,
  SPACES
} from '../routes'

interface Params {
  importTo?: string
}

interface Props {
  children: React.ReactNode
  spaceId: string
  gitConnectionId: string
}

const LinkToMoveSpaceAssetsGitConnections = ({
  children,
  spaceId,
  gitConnectionId,
  ...params
}: Props & Params) => {
  const url = `/${SPACES}/${spaceId}/${ASSETS}/${EDIT}/${GIT_CONNECTIONS}/${gitConnectionId}/${MOVE}`

  return (
    <StyledLink to={makeQueryString(url, { ...params })}>
      {children}
    </StyledLink>
  )
}

export default LinkToMoveSpaceAssetsGitConnections
